var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-09"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9974 12.5435C12.8272 12.8264 13.3307 13.1981 13.3307 13.6051C13.3307 14.4915 10.9429 15.2101 7.9974 15.2101C5.05188 15.2101 2.66406 14.4915 2.66406 13.6051C2.66406 13.1981 3.16758 12.8264 3.9974 12.5435",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 6.87695C10 7.98155 9.1046 8.87695 8 8.87695C6.8954 8.87695 6 7.98155 6 6.87695C6 5.77239 6.8954 4.87695 8 4.87695C9.1046 4.87695 10 5.77239 10 6.87695Z",
    stroke: "#64748B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 1.87695C10.7059 1.87695 13 4.16231 13 6.93489C13 9.75162 10.6685 11.7283 8.515 13.0724C8.35807 13.1628 8.1806 13.2103 8 13.2103C7.8194 13.2103 7.64193 13.1628 7.485 13.0724C5.3355 11.7152 3 9.76135 3 6.93489C3 4.16231 5.29413 1.87695 8 1.87695Z",
    stroke: "#606060",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation09);
export default __webpack_public_path__ + "static/media/location_09.1d2e16c793cb6d8469c347d7dc240f7d.svg";
export { ForwardRef as ReactComponent };